import { appRoutes } from '@/routes';

const routes = appRoutes();

export const addEmployeeTourSteps = [
  {
    id: 'sidebar-add-employee',
    path: routes.teamDashboard,
    // The sidebar <li> (#add-employee) is just a hook id — its visible pill
    // is the reactstrap <NavLink class="nav-link"> child, so the highlight
    // must target that directly (an outset shadow on the <li> gets clipped
    // by the scrollable nav list's overflow-x, and an inset shadow on the
    // <li> paints behind the opaque child and never shows).
    target: '#add-employee .nav-link',
    content:
      'You can find "Add Employee" here in the sidebar anytime you want to add new team members.',
    placement: 'right',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '8px',
    },
  },
  {
    id: 'invite-members',
    path: routes.employeeList,
    target: '[data-tour="invite-members-btn"]',
    content:
      'Click "Invite Employee" to start adding employees to your workspace.',
    placement: 'bottom',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '12px',
    },
  },
  {
    id: 'select-team',
    path: routes.addEmployee,
    target: '[data-tour="add-employee-dropdowns"]',
    content: 'Select the department this employee will belong to.',
    placement: 'bottom',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '4px',
    },
  },
  {
    id: 'entry-method',
    path: routes.addEmployee,
    target: '[data-tour="add-employee-tabs"]',
    content:
      'Three ways to bring people in — upload an Excel/CSV file, add employees manually one at a time, or import from an integration like Google Workspace or Microsoft 365.',
    placement: 'bottom',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '4px',
    },
  },
  {
    id: 'upload-excel',
    path: routes.addEmployee,
    target: '[data-key="uploadExcel"]',
    content:
      'Import via Excel/CSV is great for bulk onboarding — download the template, fill in your employee list, and upload it here.',
    placement: 'bottom',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '10px 34px',
    },
  },
  {
    id: 'employee-form',
    path: routes.addEmployee,
    target: '[data-tour="manual-entry-table"]',
    clickBefore: '[data-key="manualEntry"]',
    content:
      "Prefer to add people one at a time? Switch to Add Employees Manually and fill in each employee's email, name, timezone, and role.",
    placement: 'top',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '4px',
    },
  },
  {
    id: 'send-invitations',
    path: routes.addEmployee,
    target: '[data-tour="send-invitations-btn"]',
    content:
      'Once done, click here to send invitation emails. Employees will receive instructions to download and install Prodaff.',
    placement: 'top',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '8px',
    },
  },
];
